<template>

    <div class="hero-items-container">
    <h2>Active Items</h2>
    <draggable :list="list" @start="drag = true" @end="drag = false" item-key="order">
        <template #item="{element}">
            <div class="bg-alt-yellow flex-x extra-rounded p-3 mb-4 hero-item" style="align-items: center; justify-content: space-between; cursor: grab;">
                <p class="m-0">{{ element.order }} - {{ element.title ?? element.name }} - {{ element.custom_text ?? "" }}</p>
                <button type="button" class="btn btn-warning mx-2 delete-hero-button" @click="this.Delete(element.hero_id)">Delete</button>
            </div>
        </template>
    </draggable>

    </div>

    <button type="submit" class="btn btn-warning" @click="this.Save()">Save Hero Banner Order</button>

</template>

<script>

import draggable from 'vuedraggable'

export default {

    data () {
        return {
            list: [],
            drag: false
        }
    },

    components: {
        draggable
    },

    props: ['items'],

    created () {
        this.list = this.items;
    },

    methods: {

        Save () {
            axios.post('/admin/hero/update_order', {
                data: this.list
            })
            .then(function (response) {
                window.Toast('Hero Banner Order has been updated!');
            });
        },

        Delete (id) {
            axios.post('/admin/hero/delete', {
                id: id
            })
            .then( (response) => {
                const key = this.list.findIndex(a => a.hero_id == id);
                this.list.splice(key, 1);
                Toast('Hero Banner Item has been deleted');
            });
        }

    }

}
</script>